import React from 'react';
import { FlexWrapper } from 'Shared/FlexWrapper';
import styles from './user-summary.module.css';

interface UserSummaryProps {
    name: string;
    email: string;
}

function UserSummary({ name, email }: UserSummaryProps): React.ReactElement<UserSummaryProps> {
    return (
        <FlexWrapper column align="start" justify="start" className={styles.UserSummary}>
            <p>
                <b title={name}>{name}</b>
            </p>
            <p title={email}>{email}</p>
        </FlexWrapper>
    );
}

export default UserSummary;
